<template>
  <!-- 物料列表 -->
  <div class="form">
    <div class="container">
      <!-- 上方表单 -->
      <el-form label-width="100px">
        <el-row>
          <el-col span="6">
            <el-form-item label="物料类型：">
              <el-select
                style="width: 100%"
                v-model="typeName"
                ref="typeSelect"
                placeholder="请选择 物料类型"
                clearable
              >
                <el-option>
                  <el-tree
                    ref="typeTree"
                    :props="typeTreeProps"
                    :load="getTypeTree"
                    node-key="name"
                    check-strictly
                    lazy
                    check-on-click-node
                    :expand-on-click-node="false"
                    @node-click="typeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="物料名称：">
              <el-input
                v-model="searchForm.name"
                placeholder="物料名称"
                :maxlength="50"
                :show-word-limit="true"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="物料编码：">
              <el-input
                v-model="searchForm.code"
                placeholder="物料编码"
                :maxlength="50"
                :show-word-limit="true"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="型号规格：">
              <el-input
                v-model="searchForm.specification"
                placeholder="型号规格"
                :maxlength="50"
                :show-word-limit="true"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col span="6" v-if="needStoreInfo">
            <el-form-item label-width="20px">
              <el-checkbox v-model="isNoEmpty">
                <span style="color: #409EFF">显示非0库存物料</span>
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="needStoreInfo ? 18 : 24">
            <el-form-item>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange"
                  >搜索</el-button
                >
                <el-button plain icon="el-icon-delete" size="small" @click="searchReset"
                  >清除</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 下方列表 -->
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="listData"
        :page.sync="tablePage"
        @on-load="loadData"
        @selection-change="selectionChange"
      >
      </avue-crud>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">确定</el-button>
      <el-button size="small" @click="doClose('cancel')">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getGoodsListApi, getGoodsTypeTreeApi } from '@/api/warehouse/goods';

export default {
  name: 'GoodsList',
  props: {
    projectId: {
      type: String,
      default: '',
    },
    warehouseId: {
      type: String,
      default: '',
    },
    // 是否需要库存信息
    needStoreInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        typeId: '', // 物料类型
        name: '', // 物料名称
        code: '', // 物料编码
        specification: '', // 物料规格
      },
      // 物料类型树的节点属性
      typeTreeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'isLeaf',
        disabled: 'disabled',
      },
      // 当前选择的物料类型
      typeName: '',
      // 是否显示非0库存
      isNoEmpty: false,
      // 列表数据
      listData: [],
      // 选中的项
      selectedList: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  computed: {
    // 表格选项
    tableOption() {
      return {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        selection: true,
        reserveSelection: true,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '物料类型',
            prop: 'typeName',
          },
          {
            label: '物料编码',
            prop: 'code',
          },
          {
            label: '物料名称',
            prop: 'name',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: 'measuringUnitName',
          },
          {
            label: '当前总库存',
            prop: 'stockNum',
            hide: this.needStoreInfo ? false : true,
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      };
    },
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      let params = {
        current: page.currentPage,
        size: page.pageSize,
        projectId: this.projectId,
        warehouseId: this.warehouseId,
      };
      if (this.needStoreInfo) {
        params.emptyDisplayFlag = this.isNoEmpty ? 0 : 1;
      }
      getGoodsListApi(Object.assign(params, this.searchForm)).then(({ data }) => {
        this.tablePage.total = data.total;
        // 后端返回的id都是null，但是做翻页勾选时需要用到唯一的id
        this.listData = data.records.map((item) => {
          item.id = item.consumableId;
          return item;
        });
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {};
      this.typeName = '';
      this.isNoEmpty = false;
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      // 搜索时清空之前勾选的
      this.$refs.crud.toggleSelection();
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 获取分类树 */
    getTypeTree(node, resolve) {
      getGoodsTypeTreeApi({
        parentId: node.level === 0 ? 0 : node.data.id,
        projectId: this.projectId,
      }).then((res) => {
        resolve(res.data);
      });
    },
    /* 点击分类树的节点 */
    typeClick(data) {
      this.searchForm.typeId = data.id;
      this.typeName = data.name;
      this.$refs.typeTree.setCheckedNodes([data]);
      this.$refs.typeSelect.blur();
    },
    /* 勾选项发生变化 */
    selectionChange(val) {
      this.selectedList = val;
    },
    doSave() {
      if (this.selectedList.length == 0) {
        this.$message.warning('请先勾选物料');
        return;
      }
      this.$emit('update', this.selectedList);
      this.doClose('save');
    },
    doClose(type) {
      this.$emit('close', type);
      this.$refs.crud.toggleSelection();
      this.selectedList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
